module.exports = __webpack_public_path__ + "media/images/icon-cog-8582b759abd6a835565bde97f292c747.png";